import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { SOFTWARE_CHANNEL_ID } from '../../../shared/constants';
import { updateDeviceProperties } from '../../../store/devices/actionCreators';
import { Device, DevicesStore } from '../../../store/devices/deviceTypes';
import { SoftwareChannel } from '../../../store/GlobalTypes';
import StyledSelect from '../../Shared/StyledSelect';

interface UpdateDeviceChannelProps {
  device: Device;
  // v2 callers pass this to refresh their own device slice; the classic
  // updateDeviceProperties thunk only refreshes the legacy device list.
  onUpdated?: () => void;
}

const UpdateDeviceChannel = (props: UpdateDeviceChannelProps) => {
  const { device, onUpdated } = props;
  const dispatch = useDispatch<ThunkDispatch<DevicesStore, void, AnyAction>>();

  const [deviceChannel, setDeviceChannel] = useState(
    device.software_channel_id,
  );

  if (!device) {
    return null;
  }
  return (
    <Grid
      container
      spacing={1}
      justifyContent="flex-end"
      style={{ marginBottom: 5 }}
    >
      <Grid item xs="auto">
        <FormControl required variant="outlined" sx={{ minWidth: '200px' }}>
          <StyledSelect
            value={String(deviceChannel)}
            onChange={(e: SelectChangeEvent<string>) => {
              setDeviceChannel(Number(e.target.value));
            }}
            sx={{ width: '200px', textAlign: 'left' }}
          >
            {Object.keys(SOFTWARE_CHANNEL_ID).map((channel) => (
              <MenuItem
                key={channel}
                value={String(
                  (SOFTWARE_CHANNEL_ID as SoftwareChannel)[channel],
                )}
              >
                {channel}
              </MenuItem>
            ))}
          </StyledSelect>
        </FormControl>
      </Grid>
      <Grid item xs="auto">
        <Button
          variant="contained"
          color="secondary"
          disabled={deviceChannel === device.software_channel_id}
          onClick={async () => {
            await dispatch(
              updateDeviceProperties(device.id, {
                software_channel_id: deviceChannel,
              }),
            );
            onUpdated?.();
          }}
        >
          Update channel
        </Button>
      </Grid>
    </Grid>
  );
};

export default UpdateDeviceChannel;
